module.exports = __webpack_public_path__ + "static/img/successCaseDetailTop.c7d9390.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/successCaseDetailTop.png
// module id = s2G9
// module chunks = 2